(function(){
  if (window.__kvWow) return; window.__kvWow = true;
  var d = document; d.documentElement.classList.add('kv-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el){
    if (el._kvc) return; el._kvc = 1;
    var m = (el.textContent || '').trim().match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
    if (!m || reduce) return;
    var end = parseFloat(m[2]), dec = (m[2].split('.')[1] || '').length, t0 = null;
    function f(t){ t0 = t0 || t; var p = Math.min((t - t0) / 1600, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = m[1] + (end * e).toFixed(dec) + m[3]; if (p < 1) requestAnimationFrame(f); }
    requestAnimationFrame(f);
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); if (e.target.hasAttribute('data-kv-count')) countUp(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;
  function sliders(r){
    r.querySelectorAll('[data-kv-slider]').forEach(function(s){
      if (s._kv) return; s._kv = 1;
      var items = [].slice.call(s.querySelectorAll('.kv-slide')), dots = [].slice.call(s.querySelectorAll('.kv-dot'));
      if (items.length < 2) return;
      var i = 0, t, ms = (parseFloat(s.getAttribute('data-speed')) || 6) * 1000;
      function go(n){ items[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + items.length) % items.length; items[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active'); }
      function play(){ clearInterval(t); t = setInterval(function(){ go(i + 1); }, ms); }
      dots.forEach(function(dt, n){ dt.addEventListener('click', function(){ go(n); play(); }); });
      play();
    });
  }
  function tilts(r){
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    r.querySelectorAll('[data-kv-tilt]').forEach(function(c){
      if (c._kv) return; c._kv = 1;
      c.addEventListener('pointermove', function(e){ var b = c.getBoundingClientRect(), x = (e.clientX - b.left) / b.width - 0.5, y = (e.clientY - b.top) / b.height - 0.5;
        c.style.transform = 'perspective(900px) rotateX(' + (-y * 6) + 'deg) rotateY(' + (x * 7) + 'deg) translateY(-6px)'; });
      c.addEventListener('pointerleave', function(){ c.style.transform = ''; });
    });
  }
  var px = [], ticking = false;
  function onScroll(){
    if (ticking || reduce) return; ticking = true;
    requestAnimationFrame(function(){
      var h = window.innerHeight;
      px.forEach(function(el){ var b = el.parentElement.getBoundingClientRect(); if (b.bottom < -100 || b.top > h + 100) return;
        var p = (b.top + b.height / 2 - h / 2) / (h + b.height);
        el.style.transform = 'translate3d(0,' + (p * -(parseFloat(el.getAttribute('data-kv-parallax')) || 60)) + 'px,0)'; });
      ticking = false;
    });
  }
  function init(r){
    r = r || d; sliders(r); tilts(r);
    r.querySelectorAll('[data-kv-reveal]:not(.is-in),[data-kv-count]').forEach(function(el){ if (io) io.observe(el); else el.classList.add('is-in'); });
    px = [].slice.call(d.querySelectorAll('[data-kv-parallax]')); onScroll();
  }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', function(){ init(); });
  d.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll);
  d.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();